// libs
import { Navigate, Routes } from 'react-router-dom';
// components
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import CandidateContext from 'domain/recruiting/candidate/CandidateContext';
import CandidateViewPage from 'domain/recruiting/candidate/Show';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, createRoute } from 'framework/routing';

// recruiting services
import { RECRUITING_CANDIDATE_READ } from 'domain/shared/candidate';

// kernel services
import CandidateIdPage from 'domain/recruiting/candidate/CandidateIdPage';
import OfferTemplateWorkspace from './Timeline/offer/offerEditor/OfferTemplateWorkspace';
import OfferTemplateWrapper from './Timeline/offer/offerEditor/OfferTemplateWrapper';
import { CANDIDATES_PATH, useCandidateUrl } from 'domain/shared/candidate';
import { useCandidateId } from './useCandidateId';

const useCandidateRoute = () => {
  const routes = createRoute({ listRoute: CANDIDATES_PATH, editPostfix: 'profile/edit' });

  return {
    ...routes,
    profileRoute: `${routes.singleEntityRoute}/profile/:timelineEntryId?`,
    offersRoute: `${routes.singleEntityRoute}/offers/*`,
    communicationRoute: `${routes.singleEntityRoute}/communication/:timelineEntryId?`,
    createCandidateApplicationFromJobBoardRoute: `${routes.listRoute}/applications/add/job-board`,
    applicationsRoute: `${routes.singleEntityRoute}/applications`,
    editOfferRoute: `${routes.singleEntityRoute}/profile/:offerId/edit`,
  };
};

const RedirectToProfile = () => {
  const id = useCandidateId();
  const { getProfileUrl } = useCandidateUrl();
  return <Navigate to={getProfileUrl(id)} />;
};

const CandidateRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute, profileRoute, timelineRoute, editOfferRoute } = useCandidateRoute();

  return (
    <ProtectedRouter basePath={CANDIDATES_PATH}>
      <Routes>
        <Route
          path={profileRoute}
          element={
            <CandidateContext permissionToCheck={RECRUITING_CANDIDATE_READ}>
              <CandidateViewPage />
            </CandidateContext>
          }
        />

        <Route path={timelineRoute} element={<RedirectToProfile />} />
        <Route path={singleEntityRoute} element={<CandidateIdPage />} />
        <Route
          path={editOfferRoute}
          element={
            <CandidateContext permissionToCheck="">
              <OfferTemplateWrapper>
                <OfferTemplateWorkspace />
              </OfferTemplateWrapper>
            </CandidateContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

CandidateRouter.getRouterPath = () => `${CANDIDATES_PATH}/*`;

export default CandidateRouter;
